import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import Comment from "../comment";

export default function Questions({ productId }) {
  const questions = useSelector(
    (state) => state.reviewsAndQuestions.data[productId]?.QUESTIONS || [],
  );

  return (
    <div>
      {questions &&
        Array.isArray(questions) &&
        questions.map((question) => (
          <div key={question.ID} className={styles.Item}>
            <div className={styles.Author}>
              <div className={styles.Ava}>{question.NAME?.[0] || "?"}</div>
              <div className={styles.Name}>{question.NAME}</div>
              <div className={styles.Date}>{question.DATE}</div>
              <div className={styles.Rating}></div>
            </div>
            <div className={styles.Block}>
              {question.QUESTION && (
                <div className={styles.Text}>
                  <span>Вопрос</span>
                  {question.QUESTION}
                </div>
              )}

              {question.ANSWER && (
                <div className={styles.Comments}>
                  <Comment comment={question.ANSWER} />
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
